export function sanitizeSearch(value: string): string {
  const sanitized = value.replace(/[-.()\s+/]/g, '')
  const isOnlyNumbers = /^\d+$/.test(sanitized)
  const output = isOnlyNumbers ? sanitized : value

  return output
}
